import script from "./CurtainItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CurtainItem.vue?vue&type=script&setup=true&lang=js"

import "./CurtainItem.vue?vue&type=style&index=0&id=808ec4e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-808ec4e0"]])

export default __exports__